<div class="filter-content">
  <mat-expansion-panel #filterExpansion [expanded]='expended'>
    <ng-container [formGroup]="formGroup">
      <div class="filter-form-group">
        <ng-content>
        </ng-content>
      </div>
    </ng-container>

    <div class="filter-actions">
      <button mat-flat-button color='primary' (click)="doFilter()">
         {{'ACCEPT'|translate}}
      </button>
      <button mat-stroked-button color='basic' (click)="clearFilter()">
        {{'CLEAR'|translate}}
      </button>
    </div>
  </mat-expansion-panel>
</div>
